import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { trackPromise } from 'react-promise-tracker';
// import { alertActions } from '_store';
import { fetchWrapper } from '_utils';

// Create slice

const name = 'balancesheet';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

// Exports

export const balancesheetActions = { ...slice.actions, ...extraActions };
export const balancesheetReducer = slice.reducer;

// Implementation

function createInitialState() {
    return {
        fileData: null,
        uploadStatus: null,
        errorMessage: null,
        isUploading: false
    };
}

function createReducers() {
    return {
        setUploadStatus,
        clearUpload
    };

    function setUploadStatus(state, action) {
        state.uploadStatus = action.payload.status;
        state.fileData = action.payload.data;
        state.isUploading = false;
        state.errorMessage = null;
    }

    function clearUpload(state) {
        state.fileData = null;
        state.uploadStatus = null;
        state.isUploading = false;
        state.errorMessage = null;
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api/UET`;
    const baseMasterUrl = `${process.env.REACT_APP_API_URL}/api/Master`;


    return {
        createFolder: createFolder(),
        getBalancesheetList: getBalancesheetList(),
        getBalancesheetDownloadList: getBalancesheetDownloadList(),
        getBalanceSheetDownload: getBalanceSheetDownload(),
        getBalanceSheetUpload: getBalanceSheetUpload(),
        getByPathName: getByPathName(),
        updatePathName: updatePathName(),
        getBalanceSheetFilter: getBalanceSheetFilter(),
        deleteBalanceSheetFile: deleteBalanceSheetFile(),
        downloadBalanceSheetFile: downloadBalanceSheetFile(),
    };
    function createFolder() {
        return createAsyncThunk(
            `${name}/balancesheet`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/createFolder`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    function getBalanceSheetDownload() {
        return createAsyncThunk(
            `${name}/balancesheetDowloaded`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/GetDownloadFilesByPath`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

    function getBalanceSheetUpload() {
        return createAsyncThunk(
            `${name}/balancesheetUploaded`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/GetUploadFilesByPath`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    function getByPathName() {
        return createAsyncThunk(
            `${name}/balancesheetPathName`, async (name, { rejectWithValue }) => {
                try {
                    const url = new URL(`${baseMasterUrl}/GetPathByPathName?pathName=${name}`);
                    const response = await trackPromise(fetchWrapper.get(url.toString()));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
        function updatePathName() {
        return createAsyncThunk(
            `${name}/updatePathName`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/UpdateFolder`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    function getBalanceSheetFilter() {
        return createAsyncThunk(
            `${name}/balancesheetFilter`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/GetBalanceSheetFilter`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

    function deleteBalanceSheetFile() {
        return createAsyncThunk(
            `${name}/balancesheetDelete`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/DeleteFilesFromFolders`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    function downloadBalanceSheetFile() {
        return createAsyncThunk(
            `${name}/downloadBalancesheet`, async (payload, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/DownloadFilesFromFolders`, payload));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    function getBalancesheetList() {
        return createAsyncThunk(
            `${name}/getBalancesheetList`, async (_, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.get(`${baseUrl}/GetAllSupplierAreaPathName`));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    function getBalancesheetDownloadList() {
        return createAsyncThunk(
            `${name}/getBalancesheetDownloadList`, async (data, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.post(`${baseUrl}/GetDownloadFiles`, data));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

}
